export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const REMOVE_APPOINTMENT = "REMOVE_APPOINTMENT";
export const GET_APPOINTMENT = "SET_APPOINTMENT";

export const RETRIEVE_APPOINTMENTS = "RETRIEVE_APPOINTMENTS";
export const RETRIEVE_APPOINTMENTS_SUCCESS = "RETRIEVE_APPOINTMENTS_SUCCESS";
export const RETRIEVE_APPOINTMENTS_FAILURE = "RETRIEVE_APPOINTMENTS_FAILURE";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const LOGOUT = "LOGOUT";
export const SET_PRACTICE_ID = "SET_PRACTICE_ID";
export const SET_PRACTICE_LOC = "SET_PRACTICE_LOC";

export const SET_LOADING = "SET_LOADING";
export const UNSET_LOADING = "UNSET_LOADING";
export const ERROR = "ERROR";
export const OPEN_RESPONSE_MODAL = "OPEN_RESPONSE_MODAL";
export const CLOSE_RESPONSE_MODAL = "CLOSE_RESPONSE_MODAL";
export const FACILITY_CLAIMS = "FACILITY_CLAIMS";
export const SET_RESPONSE = "SET_RESPONSE";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const SET_PAYER_DASHBOARD = "SET_PAYER_DASHBOARD";
export const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE";
export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const GET_ILLNESS = "GET_ILLNESS";
export const GET_INSURANCE = "GET_INSURANCE";
export const GET_NOTES = "GET_NOTES";
export const GET_CHARGES = "GET_CHARGES";
export const SET_PATIENT = "SET_PATIENT";
export const RESET_CHARGE_ENTRY = "RESET_CHARGE_ENTRY";
// export const UPDATE_ILLNESS = "UPDATE_ILLNESS";
export const SET_ALL_PATIENTS = "SET_ALL_PATIENTS";
export const SET_PATIENT_CHARGE_ENTRY = "SET_PATIENT_CHARGE_ENTRY";
export const UPDATE_CLAIMS_ID = "UPDATE_CLAIMS_ID";
export const SET_COSTS = "SET_COSTS";
export const UPDATE_CHARGES = "UPDATE_CHARGES";
export const SET_PROVIDERS = "SET_PROVIDERS";
export const SET_PROCEDURE_COST = "SET_PROCEDURE_COST";
export const SET_DUPLICATE_RECORD = "SET_DUPLICATE_RECORD";
export const SET_SUCCESS_MODAL = "SET_SUCCESS_MODAL";
export const TOGGLE_SUCCESS_MODAL = "TOGGLE_SUCCESS_MODAL";

export const SET_EDIT_STATUS = "SET_EDIT_STATUS";

export const SET_DOC_SUCCESS = "SET_DOC_SUCCESS";

export const RESET_DOC_SUCCESS = "RESET_DOC_SUCCESS";
export const SET_PATIENT_INS_LIST = "SET_PATIENT_INS_LIST";
export const CLEAR_INSURANCE = "CLEAR_INSURANCE";
export const UPDATE_INSURANCE = "UPDATE_INSURANCE";
export const CLEAR_CHARGE_ENTRY = "CLEAR_CHARGE_ENTRY";
export const CLEAR_PAT_DETAILS = "CLEAR_PAT_DETAILS";

export const SET_ALL_ENCOUNTER = "SET_ALL_ENCOUNTER";

export const SET_PRACTICE_PATIENTS = "SET_PRACTICE_PATIENTS";
export const SET_CODES = "SET_CODES";
export const CLEAR_DASHBOARD = "CLEAR_DASHBOARD";

export const SET_BENEFITS_ARRAY = "SET_BENEFITS_ARRAY";

export const SET_BENEFITS_MODAL = "SET_BENEFITS_MODAL";

export const SET_PATIENT_SEARCH = "SET_PATIENT_SEARCH";
export const CLEAR_BENEFIT_DATA = "CLEAR_BENEFIT_DATA";

export const STORE_ERA_LIST = "STORE_ERA_LIST";
export const RESET_ERA_LIST = "RESET_ERA_LIST";

export const STORE_ERA_CURRENT = "STORE_ERA_CURRENT";
export const SET_ERA_MODAL = "SET_ERA_MODAL";
export const STORE_ERA_PDF = "STORE_ERA_PDF";

export const CHANGE_DASHBOARD_FILTER = "CHANGE_DASHBOARD_FILTER";
export const CHANGE_DOCUMENT_FILTER = "CHANGE_DOCUMENT_FILTER";
export const CHANGE_DOCUMENT_SORT = "CHANGE_DOCUMENT_SORT";
export const SET_REPORT_TYPE = "SET_REPORT_TYPE";

export const SET_PENDING_DOCUMENTS = "SET_PENDING_DOCUMENTS";
export const SET_ALL_DOCUMENTS = "SET_ALL_DOCUMENTS";
//  For Dropdown : Dashboard
export const SET_INS_CAR_NAME = "SET_INS_CAR_NAME";
export const SET_DIAGNOSIS = "SET_DIAGNOSIS";
export const SET_PROCEDURE = "SET_PROCEDURE";
export const SET_MODIFIER = "SET_MODIFIER";
export const CLEAR_ERA = "CLEAR_ERA";
export const SWITCH_CHARGE_ENTRY_VIEW = "SWITCH_CHARGE_ENTRY_VIEW";
export const ADD_DOCUMENT_TAGS = "ADD_DOCUMENT_TAGS";
export const SET_ADV_DOCUMENT_SEARCH = "SET_ADV_DOCUMENT_SEARCH";
export const RESET_ADV_DOCUMENT_SEARCH = "RESET_ADV_DOCUMENT_SEARCH";
